import { atom } from 'recoil';


/**
 * Create store save ticket type list 
 */
export const ticketListTypeState = atom({
    key: 'ticketListTypeState',
    default: ''
});


/**
 * Create store save isOpenAddTicketState
 */
export const isOpenAddTicketState = atom({
    key: 'isOpenAddTicketState',
    default: false
});

export const isExChangeTicket = atom({
    key: 'isExChangeTicket',
    default: false
});

/**
 * Tab display in ticket list (internal, external, customer support,....)
 */
export const ticketListTabState = atom({
    key: 'ticketListTabState',
    default: ''
});
